import { OnboardingStatus } from "types/Onboarding";

export function getOnboardingStatusTone(
  status: OnboardingStatus | string | undefined
): string {
  switch (status) {
    case "step_1":
    case "step_2":
    case "step_3":
    case "step_4":
    case "work_security":
    case "step_5":
      return "attention";
    case "completed":
      return "success";
    case "cancelled":
      return "critical";
    default:
      return "info";
  }
}

export function getOnboardingStatusLabel(
  status: OnboardingStatus | string | undefined,
  t: (key: string) => string,
  lang?: "lt" | "en"
): string {
  if (status === "completed") return t("completed");
  if (status === "cancelled") return t("cancelled");
  if (status && STEP_LABELS[status]) {
    const l = lang || "lt";
    return STEP_LABELS[status][l] || STEP_LABELS[status].en;
  }
  return status || "-";
}

export const STEP_LABELS: Record<string, { lt: string; en: string }> = {
  step_1: { lt: "Įdarbinimo anketa", en: "Hiring Questionnaire" },
  step_2: { lt: "Darbuotojo formos", en: "Employee Forms" },
  step_3: { lt: "Sveikatos patikra", en: "Medical Check" },
  step_4: { lt: "Darbo sutartis", en: "Employment Contract" },
  work_security: { lt: "Tvarkos", en: "Procedures" },
  step_5: { lt: "Darbuotojo aktyvavimas", en: "Employee Activation" },
};

export const ALL_STEPS = [
  "step_1",
  "step_2",
  "step_3",
  "step_4",
  "work_security",
  "step_5",
] as const;

// Informational: generated for the employee's records, never signed, so never scanned.
export const STEP_2_QUESTIONNAIRE_FILE_TYPE = "step_2_questionnaire_pdf";

export const STEP_2_FILE_TYPES = [
  "step_2_esign_pdf",
  STEP_2_QUESTIONNAIRE_FILE_TYPE,
  "step_2_application_pdf",
  "step_2_gdpr_pdf",
] as const;

export function getStepFileId(stepFile: { file?: unknown } | null | undefined): string | null {
  if (!stepFile) return null;
  if (typeof stepFile.file === "object") {
    return (stepFile.file as { id?: string })?.id || null;
  }
  return typeof stepFile.file === "string" ? stepFile.file : null;
}

/** User id on signature rows — API may return a string or a populated user object. */
export function getSignatureUserId(sig: { user?: unknown }): string {
  const u = sig.user;
  if (u == null || u === "") return "";
  if (typeof u === "object" && u !== null && "id" in u) {
    return String((u as { id?: string }).id ?? "");
  }
  return String(u);
}

/** Display label when userName may be missing and user may be populated. */
export function getSignatureUserLabel(sig: {
  user?: unknown;
  userName?: string;
}): string {
  if (sig.userName) return sig.userName;
  const u = sig.user;
  if (u != null && typeof u === "object") {
    const o = u as { name?: string; email?: string; id?: string };
    return o.name || o.email || o.id || "";
  }
  return u != null ? String(u) : "";
}
